import { FC, useMemo } from "react";
import { CardRender } from "../../../../../../../shared/components/CardRender";
import { RejectedDebits } from "../../../../../../../shared/interfaces/services/rejected-credits";
import { formattedPrice } from "../../../../../../../shared/utils";
import { REJECTIONS_TYPES_VALUES, RejectionsTypesValues } from "../../../shared/enums/rejections-types-enum";

interface RejectedDebitsCardProps {
    rejections: RejectedDebits;
    loading?: boolean;
    tabType?: RejectionsTypesValues;
}

export const RejectedDebitsCard: FC<RejectedDebitsCardProps> = ({
    rejections,
    loading,
    tabType
}) => {

    const {
        rama,
        descripcioRama,
        poliza,
        endoso,
        asegurado,
        importe,
        numeroPago,
        numeroRechazo,
        motivoRechazo
    } = rejections;

    const columnsDataRejection = useMemo(() => [
        {
            label: 'Póliza',
            value: poliza,
            isLikeTitle: true,
            valueInBold: true,
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },

        },
        {
            label: 'Asegurado',
            value: asegurado,
            valueInBold: true,
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: 'Rama',
            value: descripcioRama,
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: 'Número de rechazo',
            value: numeroRechazo,
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: 'Moneda origen',
            value: 'PESOS',
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: 'Importe',
            value: `$${formattedPrice(importe)}`,
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: 'Descripción',
            value: motivoRechazo || '-',
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: tabType === REJECTIONS_TYPES_VALUES.CREDITO ? 'Número de tarjeta' : 'Número de CBU',
            value: numeroPago.trim().replace(/^0+/, ''),
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
    ], [poliza, asegurado, rama, numeroRechazo, importe]);
    

     return (
        <CardRender
            title={''}
            article={undefined}
            tags={undefined}
            actions={undefined}
            loading={loading}
            columnsData={columnsDataRejection}
        />
    );
}